import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewGraficoConsumoCorral = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'grafico_consumo_corral',
        name: 'Gráfico Consumo Corral',
        component: ViewGraficoConsumoCorral,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router